import { useModalNavigate } from "hooks/useModalNavigate"
import { useCallback } from "react"
import { useLocation, useParams } from "react-router"

export function useNavigateToScreening() {
	const { scopeId, userId } = useParams()
	const location = useLocation()
	const modalNavigate = useModalNavigate()

	return useCallback(
		(screeningId: string) => {
			if (!scopeId || !userId) {
				return
			}
			modalNavigate(
				`/${encodeURIComponent(scopeId)}/patients/${encodeURIComponent(userId)}/m/screenings/${encodeURIComponent(screeningId)}${location.search}`,
			)
		},
		[location.search, modalNavigate, scopeId, userId],
	)
}
